import * as tvx from "../../lib/tvx-plugin-module.min";
import {
  MSXContentRoot,
  MSXContentItem,
  MSXContentPage,
} from "../../lib/tvx-plugin-module.min";

import {
  res_audio_tracks,
  res_blackColor,
  res_country,
  res_description,
  res_director,
  res_imdb_rating,
  res_information,
  res_need_to_sign_in,
  res_no_info,
  res_subtitles,
  res_watch_now,
  res_year,
  res_yellowColor,
  res_you_may_also_like,
  SERVER_ADDRESS,
  serviceMap,
} from "../../static-res";
import {
  base64ToObj,
  callCallback,
  createContentRequest,
  isLogin,
  validateAccountForProtectedAction,
  stopLoadingShowError,
  STORAGE_PREFIX_ID,
} from "../../utils";
import { getMovieInfo } from "../../api/worker";
import { apiMovie, apiSerial, FictionState } from "../../api/api-models";
import {
  getCurrentlyDisplayingItemByIndex,
  getDisplayedItems,
  playerProperties,
  truncateString,
} from "../content-utils";
import {
  createFictionAlsoLikeRow,
  createFictionInfo,
  getFictionState,
} from "./fiction";

function createMovieVideoURL(movieId: string): string {
  return `${SERVER_ADDRESS}hls.html?url=https://scrennnifu.click/movie/${movieId}/playlist.m3u8&id=${movieId}&type=movie`;
}

function createMovieAction(movie: apiMovie): string {
  const fixedImage = movie.portraitImage ? movie.portraitImage.replace("@", "$") : "";

  return `video:resolve:request:interaction:video:watch:movie|plugin:${createMovieVideoURL(
    movie.imdbid
  )}|${movie.title}|${fixedImage}`;
}

// Функция для проверки авторизации с валидацией токена
function isUserAuthenticated(): boolean {
  // Сначала проверяем базовый флаг логина
  if (!isLogin()) {
    return false;
  }
  
  // Затем проверяем валидность токена и данных пользователя
  return validateAccountForProtectedAction();
}

function createMovieHeaderPage(movie: apiMovie): MSXContentPage {
  const page: MSXContentPage = {
    items: [
      {
        id: "moviePoster",
        type: "teaser",
        layout: "0,0,3,4",
        image: movie.portraitImage,
        imageFiller: "cover",
        stampColor: res_blackColor,
        progressColor: res_yellowColor,
      },
      {
        type: "default",
        layout: "0,4,3,1",
        title: res_watch_now(),
        icon: "play-arrow",
        iconSize: "medium",
        imageWidth: 1,
        imageOverlay: 0,
        centration: "title",
        alignment: "center",
        action: isUserAuthenticated()
          ? createMovieAction(movie)
          : `info:${res_need_to_sign_in()}`,
      },
    ],
  };

  const maxCharsInLine = 88;
  page.items.push(
    {
      type: "default",
      headline: res_description(),
      text: truncateString(movie.description, maxCharsInLine * 4),
      alignment: "top",
      centration: "text|title",
      layout: "3,0,9,2",
    },
    {
      type: "default",
      headline: res_audio_tracks(),
      text: truncateString(
        movie.audioTracks.flatMap((audio) => audio.name).join(", "),
        maxCharsInLine
      ),
      alignment: "top",
      centration: "text|title",
      layout: "3,2,9,1",
    },
    {
      type: "default",
      headline: res_subtitles(),
      text: truncateString(
        movie.subtitleTracks.flatMap((sub) => sub.name).join(", "),
        maxCharsInLine
      ),
      alignment: "top",
      centration: "text|title",
      layout: "3,3,9,1",
    }
  );

  const state = getFictionState(movie.imdbid);
  const progress = state != null ? state.position / state.duration : 0;
  const stamp =
    state != null
      ? tvx.DateTools.getFormattedDurationStr(state.position * 1000, "hh:mm:ss")
      : "";
  page.items[0].stamp = stamp;
  page.items[0].progress = progress;

  return page;
}

export function createMovieRoot(
  movieId: string,
  callback: (data: any) => void
): void {
  getMovieInfo(movieId).then((movie) => {
    if (movie != null) {
      const movieRoot: MSXContentRoot = {
        name: `${movie.title} - ${movie.releaseYear}`.toUpperCase(),
        headline: `${movie.title} - ${movie.releaseYear}`.toUpperCase(),
        flag: "movie",
        important: true,
        background: `${movie.portraitImage}#msx-keep-ratio`,
        type: "list",
        pages: [createMovieHeaderPage(movie)],
      };

      createFictionAlsoLikeRow("movie", movieId).then((page) => {
        movieRoot.pages.push(page);
        movieRoot.pages.push(createFictionInfo(movie));
        callCallback(movieRoot, callback);
      });
    } else {
      stopLoadingShowError(null, callback);
    }
  });
}
